import { RECURRINGDETAILES_SUCCESS, RECURRINGDETAILES_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const recurringDetailesReducer = (state = initialState, action) => {
    switch (action.type) {
        case RECURRINGDETAILES_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case RECURRINGDETAILES_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default recurringDetailesReducer;
